import React from "react";
import CrudPage from "@/components/CrudPage";
import { companiesApi } from "@/lib/orgApi";

const CompaniesPage = () => (
    <CrudPage
        title="Companies"
        subtitle="Healthcare companies that own one or more providers."
        api={companiesApi}
        testidPrefix="companies"
        columns={[
            { key: "name", label: "Name" },
            { key: "tax_id", label: "Tax ID" },
            {
                key: "active",
                label: "Status",
                render: (r) =>
                    r.active ? (
                        <span className="rounded-full bg-brand-green-100 px-2.5 py-1 text-xs font-semibold text-brand-green-800">
                            Active
                        </span>
                    ) : (
                        <span className="rounded-full bg-slate-200 px-2.5 py-1 text-xs font-semibold text-slate-600">
                            Inactive
                        </span>
                    ),
            },
        ]}
        fields={[
            { name: "name", label: "Company name", required: true },
            { name: "tax_id", label: "Tax ID" },
            { name: "active", label: "Active", type: "boolean", default: true },
        ]}
    />
);

export default CompaniesPage;
